import React from 'react';
import PropTypes from 'prop-types';

const ContactAddress = ({
  renter,
  company,
  address,
  city,
  state,
  zip,
  country,
}) => (
  <>
    {renter && <p>{company}</p>}
    <p>{address}</p>
    <p>{`${city}, ${state}, ${zip}, ${country}`}</p>
  </>
);
ContactAddress.propTypes = {
  renter: PropTypes.bool.isRequired,
  company: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zip: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
};

const View = ({
  contactSame,
  contactRenter,
  contactPhone,
  contactEmail,
  contactFirstName,
  contactLastName,
  contactCompany,
  contactAddress,
  contactCity,
  contactState,
  contactZip,
  contactCountry,
  show,
}) =>
  show && (
    <>
      <p>
        {contactFirstName} {contactLastName}
      </p>
      {!contactSame && (
        <ContactAddress
          renter={contactRenter}
          company={contactCompany}
          address={contactAddress}
          city={contactCity}
          state={contactState}
          zip={contactZip}
          country={contactCountry}
        />
      )}
      <p>
        {contactPhone} - <span className="word-break-all">{contactEmail}</span>
      </p>
    </>
  );

View.propTypes = {
  contactRenter: PropTypes.bool.isRequired,
  contactSame: PropTypes.bool.isRequired,
  contactPhone: PropTypes.string.isRequired,
  contactEmail: PropTypes.string.isRequired,
  contactFirstName: PropTypes.string.isRequired,
  contactLastName: PropTypes.string.isRequired,
  contactCompany: PropTypes.string.isRequired,
  contactAddress: PropTypes.string.isRequired,
  contactCity: PropTypes.string.isRequired,
  contactState: PropTypes.string.isRequired,
  contactZip: PropTypes.string.isRequired,
  contactCountry: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

export default View;
